import { getConversationRpc } from '../../__generated__/chirp/com/hubspot/breeze/engine/rpc/BreezeEngineConversationsService';
const DEFAULT_PAGE_LENGTH = 50;
export function createConversationHistory(chirpClient) {
  return {
    async getConversation(request) {
      const response = await chirpClient.call(getConversationRpc, {
        request: Object.assign({}, request, {
          pageLength: DEFAULT_PAGE_LENGTH
        })
      });
      return {
        results: response.results,
        hasMore: response.hasMore,
        offset: response.offset,
        agentId: response.agentId,
        title: response.title,
        status: response.status,
        feedbackByKey: response.feedbackByKey
      };
    }
  };
}